import React from "react";
import classnames from "classnames";
import BranchLink from "web/react/components/branch-link/branch-link";
import styles from "./send-to-app.css";

export interface SendToAppProps {
    title?: string;
    url: string;
    analyticsEventLabel: string;
    productImageURL?: string | null;
    downloadCTA: string;
    extraContent?(): JSX.Element;
    className?: string;
    appDeepLinkURL?: URL;
    financialIncentiveWebviewToken?: string;
}

export default function SendToApp({
    title,
    productImageURL,
    analyticsEventLabel,
    url,
    downloadCTA,
    extraContent,
    className,
    appDeepLinkURL: appDeepLinkURL,
    financialIncentiveWebviewToken,
}: SendToAppProps): JSX.Element {
    return (
        <div className={classnames(className, styles.content)}>
            {title && (
                <h1
                    className={classnames(styles.title, {
                        [styles.titleLargerMargin]: !extraContent,
                        [styles.titleSmallerMargin]: extraContent,
                    })}
                >
                    {title}
                </h1>
            )}
            <div
                className={classnames(styles.imgContainer, {
                    [styles.imgContainerLargerMargin]: !extraContent,
                    [styles.imgContainerSmallerMargin]: extraContent,
                })}
            >
                {productImageURL && <img src={productImageURL} className={styles.productImg} />}
                <div
                    role="presentation"
                    className={classnames(styles.img, {
                        [styles.smallImg]: productImageURL != null,
                        [styles.largeImg]: productImageURL == null,
                    })}
                />
            </div>
            <BranchLink
                title={downloadCTA}
                className={styles.button}
                branchLink={url}
                eventLabel={analyticsEventLabel}
                appDeepLinkURL={appDeepLinkURL}
                financialIncentiveWebviewToken={financialIncentiveWebviewToken}
                primaryButton
            />
            {extraContent && extraContent()}
        </div>
    );
}
